export default __webpack_public_path__ + "static/404-img-1-d393ac38c723b2b9b1bfeb6b2007a59d.png";